export default __webpack_public_path__ + "static/media/pexels-brett-sayles-3633711.0657a4bb.jpg";